<template>
  <div class="study-task-report">
    <div class="desc" >
      {{ detail.description }}
    </div>
    <div class="btn" @click.stop="showPopupImage">
      <img  v-if="detail.obtained" v-lazy="detail.image" alt="">
      <template v-else>
        <img v-lazy="detail.image" alt="">
        <div class="cover" >
          <img src="@/assets/img/exercise/unobtained.png">
          <div>学习任务达标后<br>即可获得证书</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { appPort, imagePreview } from '@/widget/index'
import { ImagePreview } from 'vant';
const props = defineProps({
  detail: {
    type: Object,
    default: () => {
      return {}
    }
  }
})
const showPopupImage = () => {
  if (!props.detail.obtained) {
    return;
  }
  let images = [props.detail.image]
  let picIndex = 0;
  if (appPort()) {
    imagePreview({ typeId: "image_preview", images: images, posIndex: picIndex })
  } else {
    ImagePreview({
      images: images,
      closeable: true,
      startPosition: picIndex
    })
  }
}
</script>

<style lang="scss" scoped>
.study-task-report {
  .desc {
    color: #626366;
    font-size: 28px;
    line-height: 42px;
  }
  .btn {
    width: 368px;
    min-height: 150px;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    text-align: center;
    margin-top: 30px;
    img {
      width: 100%;
    }
    .cover {
      background: rgba($color:#000, $alpha: 0.6);
      bottom: 0;
      left: 0;
      right: 0;
      top: 0;
      font-size: 24px;
      color: rgba($color: #fff, $alpha: 0.6);
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: center;
      line-height: 34px;
      img {
        width: 80px;
        height: 80px;
        display: block;
        margin: 0 auto;
      }
    }
  }
}
</style>
